(function () {
  var imgs = Array.prototype.slice.call(document.querySelectorAll('.dezoom-img'));
  if (!imgs.length) return;

  // Limites de scale
  var SCALE_MIN = 1.00;  // image en haut du viewport (après scroll down)
  var SCALE_MAX = 1.08;  // image en bas du viewport (après scroll up / avant entrée)

  // Intensité : réduit le facteur pour ralentir l'effet
  // 1.0 = pleine amplitude, 0.5 = demi-amplitude
  var INTENSITY = 0.77;

  function getScale(el) {
    var rect     = el.getBoundingClientRect();
    var viewH    = window.innerHeight;

    // Position du centre de l'image par rapport au centre du viewport
    // progress = -1 : image centrée en haut du VP (scroll down avancé)
    // progress =  0 : image centrée au milieu du VP
    // progress = +1 : image centrée en bas du VP (vient d'entrer / scroll up)
    var centerEl  = rect.top + rect.height * 0.5;
    var centerVP  = viewH * 0.5;
    var progress  = (centerEl - centerVP) / centerVP;

    // Applique l'intensité pour atteindre les extremes plus lentement
    progress = progress * INTENSITY;

    // Clamp dans [-1, 1]
    progress = Math.max(-1, Math.min(1, progress));

    // Mappe [-1, 1] → [SCALE_MIN, SCALE_MAX]
    var t = (progress + 1) * 0.5;  // 0..1
    return SCALE_MIN + t * (SCALE_MAX - SCALE_MIN);
  }

  var ticking = false;

  function update() {
    for (var i = 0; i < imgs.length; i++) {
      var s = getScale(imgs[i]);
      imgs[i].style.transform = 'scale(' + s.toFixed(4) + ')';
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // État initial basé sur la position réelle de chaque image
  update();
})();
